{
  "title": "無法正式提交作品",
  "description": "點選「正式提交」後無法完成的排查方式。",
  "headings": ["症狀", "最常見原因", "排查方式", "正常結果", "仍無法解決"],
  "symptom": "點選「正式提交」後無法完成，或按鈕本身無法點選。",
  "causes": [
    "必填欄位未完成",
    "尚未標記為就緒",
    "檔案不符合限制",
    "截止時間已過",
    "投稿時間尚未開始，或所選組別已被封存"
  ],
  "diagnosis": [
    { "title": "Step 1", "description": "確認目前投稿狀態是否為「就緒」。" },
    { "title": "Step 2", "description": "確認畫面上是否有必填提示（通常標示於未完成的欄位旁）。" },
    { "title": "Step 3", "description": "確認已上傳檔案的格式與大小是否符合限制。" },
    {
      "title": "Step 4",
      "description": "確認目前時間尚未超過競賽的投稿截止時間。截止時間以競賽頁與作品繳交頁顯示的日期為準（目前輪次的投稿截止時間）。"
    }
  ],
  "resolution": "修正上述問題後，「正式提交」應可正常使用。",
  "stillStuck": ["競賽名稱", "Team ID", "發生時間", "錯誤訊息", "Screenshot"],
  "doNotProvide": ["密碼", "驗證碼", "Token"],
  "nextSteps": "確認後仍卡住，請見「如何正式提交作品」重新走一次完整步驟。"
}
